module.exports = __webpack_public_path__ + "media/src/images/buttons/facebook-6e23c251c2398cbfa35fc074fde3a08c.svg";